/*
 * Taalkiezer: alleen modalgedrag.
 * Het wisselen van markt en taal gebeurt server-side via Shopify's localisatieformulier
 * in snippets/language-switcher.liquid. Hier staat bewust geen URL-logica meer.
 */
document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('locale-trigger');
  const modal = document.getElementById('locale-modal');
  const overlay = document.getElementById('locale-modal-overlay');
  const close = document.getElementById('locale-close');

  if (!trigger || !modal || !overlay || !close) return;

  let lastFocused = null;

  function openModal() {
    lastFocused = document.activeElement;
    modal.classList.remove('hidden');
    overlay.classList.remove('hidden');
    document.body.classList.add('is-locked');
    trigger.setAttribute('aria-expanded', 'true');
    const first = modal.querySelector('button, a, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
    if (first) first.focus();
  }

  function closeModal() {
    modal.classList.add('hidden');
    overlay.classList.add('hidden');
    document.body.classList.remove('is-locked');
    trigger.setAttribute('aria-expanded', 'false');
    if (lastFocused) lastFocused.focus();
  }

  trigger.addEventListener('click', openModal);
  close.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const focusable = modal.querySelectorAll('button, a, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      last.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
      first.focus();
      e.preventDefault();
    }
  });
});
